var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#DCFCE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2909 36L18.2182 32.3429L14.2909 31.4286L14.6727 27.2L12 24L14.6727 20.8L14.2909 16.5714L18.2182 15.6571L20.2909 12L24 13.6571L27.7091 12L29.7818 15.6571L33.7091 16.5714L33.3273 20.8L36 24L33.3273 27.2L33.7091 31.4286L29.7818 32.3429L27.7091 36L24 34.3429L20.2909 36ZM21.2182 33.0857L24 31.8286L26.8364 33.0857L28.3636 30.3429L31.3636 29.6L31.0909 26.4L33.1091 24L31.0909 21.5429L31.3636 18.3429L28.3636 17.6571L26.7818 14.9143L24 16.1714L21.1636 14.9143L19.6364 17.6571L16.6364 18.3429L16.9091 21.5429L14.8909 24L16.9091 26.4L16.6364 29.6571L19.6364 30.3429L21.2182 33.0857ZM22.8545 28.0571L29.0182 21.6L27.4909 19.9429L22.8545 24.8L20.5091 22.4L18.9818 24L22.8545 28.0571Z",
    fill: "#16A34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/icon12.46e217897e1b5b7c7f2efd382e69343e.svg";
export { ForwardRef as ReactComponent };